<div class="empresa-nosotros">
  <div class="empresa-nosotros-hero">
    <img
      [src]="imgBannerEquipo"
      width="707"
      height="217"
      alt="Nuestro equipo de trabajo Rackeo"
      loading="lazy" />
  </div>

  <article class="empresa-nosotros-block empresa-nosotros-block--mision">
    <div class="empresa-nosotros-media">
      <img
        [src]="imgPolaroidMision"
        width="294"
        height="318"
        alt="Marca Rackeo en composición tipo polaroid con efecto papel rasgado"
        loading="lazy" />
    </div>
    <div class="empresa-nosotros-copy">
      <h3>Nuestra misión</h3>
      <p>
        Rackeo somos una empresa joven de gran proyección especializada en los servicios hosting de excelente calidad,
        formada para satisfacer las necesidades del incipiente crecimiento del mercado de los servicio web que se expande
        y crece de manera vertiginosa.
      </p>
    </div>
  </article>

  <mat-divider class="empresa-nosotros-divider"></mat-divider>

  <article class="empresa-nosotros-block empresa-nosotros-block--vision empresa-nosotros-block--flip">
    <div class="empresa-nosotros-media">
      <img
        [src]="imgPolaroidVision"
        width="159"
        height="184"
        alt="Ilustración estilo polaroid: brújula sobre mapa, metáfora de dirección y visión"
        loading="lazy" />
    </div>
    <div class="empresa-nosotros-copy">
      <h3>Nuestra visión</h3>
      <p>
        Toda empresa sabe que un sitio web adecuado a las necesidades actuales del mercado es tan importante como la
        productividad o contar con un personal eficiente, por eso hay que acertar al escoger su proveedor de hosting.
        Rackeo quiere ser el mejor aliado para empresas y particulares, ofreciendo unos servicios de web hosting,
        reseller, streaming, vps, servidores dedicados y colocación, punteros y a precios inmejorables.
      </p>
    </div>
  </article>

  <mat-divider class="empresa-nosotros-divider"></mat-divider>

  <article class="empresa-nosotros-block empresa-nosotros-block--equipo">
    <div class="empresa-nosotros-media">
      <img
        [src]="imgEquipo"
        width="153"
        height="174"
        alt="Teléfono y reloj: soporte y atención continua"
        loading="lazy" />
    </div>
    <div class="empresa-nosotros-copy">
      <h3>Equipo experto y calificado</h3>
      <p>
        Uno de los pilares fundamentales de nuestra empresa es nuestro personal altamente calificado, entrenados para satisfacer las necesidades de nuestros clientes y solucionar los problemas que a estos se les presenten en cualquier momento; para esto debemos mantener un flujo de comunicación constante a través del servicio de soporte, vía ticket, chat y teléfono.
      </p>
    </div>
  </article>
</div>
